export default __webpack_public_path__ + "static/hram-ikony-bozhiej-materi-sporitelnica-hlebov-krovlya_7-d2601ac2aaca517377633ac2cf9f3913.jpg";